import { render, staticRenderFns } from "./MainTsPageTemplate.vue?vue&type=template&id=1dad72a2&"
import script from "./MainTsPageTemplate.vue?vue&type=script&lang=ts&"
export * from "./MainTsPageTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports